<template>
  <v-btn
    class="UXbtn header-btn left-btn"
    outline
    v-on:click="deleteTickets"
    :disabled="isDeleteButtonDisabled"
  >
    削除
  </v-btn>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import {mapGetters} from 'vuex'
import util from '@/util'

export default {
  props: {
    callAllTicketList: Function,
    deleteTargetTicket: Array
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'currentBrandId'
    ])
  },
  data: () => ({
    isDeleteButtonDisabled: true,
    brandId: null
  }),
  created () {
    this.setBrandId()
  },
  watch: {
    deleteTargetTicket: function (val) {
      this.isDeleteButtonDisabled = val.length === 0
    }
  },
  methods: {
    deleteTickets () {
      let ticketIds = TicketListUtil.getTicketIdsFromTicketArr(this.deleteTargetTicket)
      this.axios.get(`/gateway/ticket/list/deleteValid?${TicketListUtil.listIntoGetParams('selectedTickets', ticketIds)}`)
        .then((res) => {
          let result = res.data.data
          // 삭제할 키워드가 있으면
          let message = result ? 'サブチケットがあります。</br>本当に削除しますか?' : '本当に削除しますか?'
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: `<dl class="txt"><dt>チケット削除</dt><dd>${message}</dd></dl>`,
            getBtnCount: 2,
            getLeftBtnName: 'キャンセル',
            getBtnName: '確認',
            getButtonEvent: () => {
              this.axios.delete(`/api/brand/${this.brandId}/tickets?ticketIds=${ticketIds}`).then((res) => {
                if (res.status === 200 && res.data.code === 0) {
                  this.$alertMsg('削除に成功しました。')
                  this.callAllTicketList(1, true)
                } else {
                  this.$alertMsg('削除に失敗しました。')
                }
              })
            }
          })
        })
    },
    setBrandId () {
      this.brandId = this.currentBrandId ? this.currentBrandId : util.parseLoginToken().agentMappingBrandViews[0].brandId
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/button/deleteButton.vue